module.exports = __webpack_public_path__ + "static/media/thomas_wireframe.c531e8bc.jpg";